{
  "version": 1,
  "avatars": [
    { "id": "classic", "glyph": "BG", "nameKey": "avatar.classic", "price": 0 },
    { "id": "telegram", "glyph": "TG", "nameKey": "avatar.telegram", "price": 0, "provider": "telegram" },
    { "id": "royal", "glyph": "R1", "nameKey": "avatar.royal", "price": 80 },
    { "id": "onyx", "glyph": "OX", "nameKey": "avatar.onyx", "price": 120 },
    { "id": "gold", "glyph": "GD", "nameKey": "avatar.gold", "price": 180 },
    { "id": "mint", "glyph": "MT", "nameKey": "avatar.mint", "price": 220 },
    { "id": "crown", "glyph": "CR", "nameKey": "avatar.crown", "price": 320 }
  ],
  "avatarFrames": [
    { "id": "classic", "nameKey": "avatarFrame.classic", "price": 0, "className": "miniland-avatar-frame--classic" },
    { "id": "gold-ring", "nameKey": "avatarFrame.goldRing", "price": 100, "className": "miniland-avatar-frame--gold-ring" },
    { "id": "emerald-halo", "nameKey": "avatarFrame.emeraldHalo", "price": 140, "className": "miniland-avatar-frame--emerald-halo" },
    { "id": "ruby-flare", "nameKey": "avatarFrame.rubyFlare", "price": 180, "className": "miniland-avatar-frame--ruby-flare" },
    { "id": "royal-crown", "nameKey": "avatarFrame.royalCrown", "price": 220, "className": "miniland-avatar-frame--royal-crown" },
    { "id": "cyan-orbit", "nameKey": "avatarFrame.cyanOrbit", "price": 260, "className": "miniland-avatar-frame--cyan-orbit" }
  ],
  "nameStyles": [
    { "id": "classic", "nameKey": "nameStyle.classic", "price": 0, "className": "miniland-name-style--classic" },
    { "id": "gold-serif", "nameKey": "nameStyle.goldSerif", "price": 120, "className": "miniland-name-style--gold-serif" },
    { "id": "emerald-bold", "nameKey": "nameStyle.emeraldBold", "price": 160, "className": "miniland-name-style--emerald-bold" },
    { "id": "ruby-rounded", "nameKey": "nameStyle.rubyRounded", "price": 180, "className": "miniland-name-style--ruby-rounded" },
    { "id": "royal-serif", "nameKey": "nameStyle.royalSerif", "price": 220, "className": "miniland-name-style--royal-serif" },
    { "id": "cyan-tech", "nameKey": "nameStyle.cyanTech", "price": 260, "className": "miniland-name-style--cyan-tech" }
  ],
  "alwaysOwned": {
    "avatars": ["classic", "telegram"],
    "avatarFrames": ["classic"],
    "nameStyles": ["classic"]
  }
}
